// extracted by mini-css-extract-plugin
export default {"loginBox":"styles_loginBox__ha7-8","imgBox":"styles_imgBox__yNKD1","formBox":"styles_formBox__4hY+N"};